import * as z from 'zod';

export const CompanyLogos = z.object({
  portalLogo: z.boolean(),
  emailLogo: z.boolean(),
  portalLogoUrl: z.string().optional(),
  emailLogoUrl: z.string().optional(),
});
export type CompanyLogos = z.infer<typeof CompanyLogos>;
